import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerHigherLogicInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.kepler.hl.url;

    if (urlToMatch && req.url.startsWith(urlToMatch)) {
        const clone = cloneAndAddHeaders(req, {
            'X-Api-Key': environment.api.kepler.hl.apiKey,
            'csdt-authorization-app': csdtAuthApp,
            'Content-Type': 'application/json',
        });
        console.debug('[Interceptors][KeplerHigherLogicInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
